import { TipoCuentaEnum } from './Const/TipoCuentaEnum';
import { NivelTensionEnum } from './Const/NivelTensionEnum';

const nivelTension = async (tipoCuentaId, form) => {
  let nivelTensionValue = null;

  switch (tipoCuentaId) {
    case TipoCuentaEnum.ACOMETIDAS_BT_INDIVIDUALES.id:
      nivelTensionValue = NivelTensionEnum.NIVEL_1.id;
      break;
    case TipoCuentaEnum.CINCO_O_MAS_ACOMETIDAS_BT.id:
      nivelTensionValue = NivelTensionEnum.NIVEL_1.id;
      break;
    case TipoCuentaEnum.LEGALIZACION_RED_BT.id:
      nivelTensionValue = NivelTensionEnum.NIVEL_1.id;
      break;
    case TipoCuentaEnum.CUENTA_TRIFASICA_BT.id:
      nivelTensionValue = NivelTensionEnum.NIVEL_1.id;
      break;
    case TipoCuentaEnum.PROVISIONAL_OBRA.id:
      nivelTensionValue = NivelTensionEnum.NIVEL_2.id;
      break;
    case TipoCuentaEnum.GESTION_ELECTROHUILA.id:
      nivelTensionValue = NivelTensionEnum.NIVEL_2.id;
      break;
    case TipoCuentaEnum.PARAMETRIZACION_MEDIDORES.id:
      nivelTensionValue = NivelTensionEnum.NIVEL_1.id;
      break;
    default:
      return null;
  }

  if (nivelTensionValue === null) {
    return null;
  }

  form.setState((statePrev) => {
    return {
      form: {
        ...statePrev.form,
        nivelTension: {
          ...form.state.form.nivelTension,
          value: nivelTensionValue,
        },
      },
    };
  });
};

export default nivelTension;
